import API from 'js/lib/api';

export default API('/api/courseraPlusSubscriptions.v1', {
  type: 'rest',
});
